import React from "react";
import cx from "classnames";
import { Alert as UnstyledAlert } from "@picklebet/ui";
import type { AlertProps as UnstyledAlertProps } from "@picklebet/ui";

import * as styles from "./ClampAlert.module.scss";

// Wraps the base alert with the padding shared by the betslip and pickslip,
// plus a trailing clamp slot for the action affordance.

export type ClampAlertProps = {
  clamp?: React.ReactNode;
} & UnstyledAlertProps;

const ClampAlert = ({
  clamp,
  children,
  className,
  ...props
}: ClampAlertProps) => {
  return (
    <UnstyledAlert
      className={cx(
        styles.alert,
        {
          [styles.hasClamp]: !!clamp,
        },
        className,
      )}
      contentClassName={styles.content}
      {...props}
    >
      <span className={styles.text}>{children}</span>
      {clamp && <div className={styles.clamp}>{clamp}</div>}
    </UnstyledAlert>
  );
};

export { ClampAlert };
